export interface ISignatureData {
    signature1: string;
    signature2: string;
    place: string;
    date: string;
    hasSignature: boolean;
    isCollectiveSignature: boolean;
    placeSignatureAfterAop: boolean;
}
